import high from '../assets/highSeverity.svg';
import low from '../assets/lowSeverity.svg';
import moderate from '../assets/moderateSeverity.svg';

const severityMap = {
  low: { label: 'Low', image: low, alt: 'lowSeverity' },
  lowWithHigh: { label: 'Low with High Risk Answers', image: high, alt: 'lowWithHighSeverity' },
  moderate: { label: 'Moderate', image: moderate, alt: 'moderateSeverity' },
  high: { label: 'High', image: high, alt: 'highSeverity' },
};

export const getSeverityDetails = (score: number, isHighScoreAnswers: boolean) => {
  if (score >= 0 && score <= 17) {
    return severityMap[isHighScoreAnswers ? 'lowWithHigh' : 'low'];
  }
  if (score > 17 && score <= 40) {
    return severityMap.moderate;
  }
  return severityMap.high;
};
